import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import cx from "classnames";
import styles from "../../../styles/CXpages.module.css"
import InternationalBrands from "../../../images/InternationalBrands.svg"
import Image from "next/image"
import Link from "next/link"
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 600,
  minWidth:350,
  bgcolor: 'background.paper',
  border: '0px solid #000',
  borderRadius: '16px',
  boxShadow: 24,
  p: 4,
  overflow:'scroll',
  height:'100%',
};

export default function BrandsModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button style={{ padding:"5px 20px" }} onClick={handleOpen}>بیشتر بخوانید</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
            <div dir="rtl">
              <h5 className={cx(styles.innerHeadings, "mb-3" )}>درج نشان مخصوص برای کالاهای غیر اصل</h5>
              <p>دیجی‌کالا با هدف حفظ حقوق مادی و معنوی برندهای معتبر و حمایت از فروشندگان و مشتریان، کالاهای اصل و غیر اصل را تفکیک می‌کند. این تفکیک به صورت نشان مخصوص (غیر اصل) روی کالاهایی که واجد شرایط اصل بودن نیستند مشخص شده است. این نشان پس از اظهار فروشنده در مورد محصول خود در پلتفرم به نمایش در می‌آید تا کاربران با آگاهی کامل نسبت به خرید کالای غیر اصل اقدام کنند و تجربه خوشایندی از خرید خود داشته باشند.</p>
              <div className={cx(styles.purpleContainer)}>
                  <div className="d-flex text-center py-3">
                    <h6>در سال ۱۴۰۱ تنها ۳ درصد از کالاهای موجود در پلتفرم دیجی‌کالا نشان غیر اصل دارند.</h6>
                  </div>
              </div>
              <p>ما برای رصد نارضایتی‌ها و بازخوردهای کاربران درباره احتمال ارسال کالاهای مغایر و غیر اصل بدون نشان، رویه‌هایی ترتیب دیده‌ایم:</p>
              <h5 className={cx(styles.innerHeadings, "mb-3" )}>آموزش به فروشندگان و برخورد با فروشندگان متخلف</h5>
              <p>تمامی فروشندگان مارکت پلیس به صورت مستمر و با هدف درج مشخصات صحیح برای کالاهایشان، آموزش‌های لازم را دریافت می‌کنند.</p>
              <div className={cx(styles.purpleContainer)}>
                  <div className="d-flex text-center py-3">
                    <h6>از ابتدای سال ۱۴۰۱  نرخ مرجوعی فروشندگانی که به دلیل ارسال کالاهای مغایر بیشترین بازگشت کالا را تجربه می‌کردند از ۷۰ درصد به ۴۰ درصد کاهش پیدا کرد.</h6>
                  </div>
              </div>
              <p>همچنین دیجی‌کالا با دو رویکرد پیشگیرانه (proactive) و واکنشی (reactive) به بررسی و احراز کالاهای اصل و غیر اصل می‌پردازد. یعنی هم خودش دست به اقداماتی برای شناسایی کالاهای مشکوک به تقلبی بودن می‌زند و هم بر اساس گزارش‌های مشتریان، خدمات پس از فروش و بخش نظارت بر عملکرد فروشندگان با فروش کالاهای غیر اصل بدون نشان مقابله می‌کند. البته شرایط جریمه بر اساس دفعات تکرار متفاوت خواهد بود. این جریمه‌ها با هر تکرار فروشنده به صورت تصاعدی اعمال می‌شود</p>
              
              <div className='text-center my-3 px-auto'>
                <Link href="/newsroom/digikala-anti-counterfeit-policy/" className='d-inline-block' >
                  <span className={cx(styles.blueContainerBtn , "px-3 py-2")}>
                  راهنمای شناسایی کالای اصل و غیر اصل در دیجی‌کالا
                  </span>
                </Link>
              </div>
            </div>
          
        </Box>
      </Modal>
    </div>
  );
}